import React, { ReactElement } from 'react';
import { Chart, registerables } from 'chart.js';
import { Line } from 'react-chartjs-2';
import FlexContainer from '../flex-container/flex-container.component';
import { COLORS } from '../../constants/system/colors';

const ChartLine: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CHART_LINE_HEIGHT: number = 300;
  const CHART_LINE_WIDTH: number = 640;
  const CHART_LINE_PADDING: number = 10;
  const CHART_LINE_BORDER_WIDTH: number = 2;
  const CHART_LINE_POINT_WIDTH: number = 3;

  const {
    containerId,
    chartItemList,
    labelFormatter,
  } = props;

  const chartLineLabelList: string[] = chartItemList.map((chartItem: ChartLineItem): string => chartItem.name);
  const chartLineValueList: number[] = chartItemList.map((chartItem: ChartLineItem): number => chartItem.value);

  Chart.register(...registerables);

  return (
    <FlexContainer isCentered style={{ height: CHART_LINE_HEIGHT }}>
      {
        chartItemList && !!chartItemList.length && (
          <Line
            id={containerId}
            height={CHART_LINE_HEIGHT}
            width={CHART_LINE_WIDTH}
            data={{
              labels: chartLineLabelList,
              datasets: [
                {
                  label: '',
                  data: chartLineValueList,
                  borderColor: COLORS.secondaryMain,
                  borderWidth: CHART_LINE_BORDER_WIDTH,
                  pointBorderWidth: CHART_LINE_POINT_WIDTH,
                  showLine: true,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  ticks: {
                    callback: (axisLabel: string | number): string => {
                      if (labelFormatter) {
                        return labelFormatter(axisLabel);
                      }

                      return axisLabel.toString();
                    },
                  },
                },
              },
              layout: {
                padding: CHART_LINE_PADDING,
              },
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  callbacks: {
                    label: (context: ChartInstance): string | undefined => {
                      if (labelFormatter) {
                        return ` ${labelFormatter(context.raw)}`;
                      }

                      return ` ${context.formattedValue}`;
                    },
                  },
                },
              },
            }}
          />
        )
      }
    </FlexContainer>
  );
});

export default ChartLine;
